import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ActionSheetIOS, Platform, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { TextInputContainer, Alert, ToolTipWrapper } from '../../components';
import { formatAmount, formatCurrency, formatPercent } from '../../utils/Functions';
import { Ionicons, MaterialCommunityIcons, FontAwesome5, FontAwesome, Entypo, Feather, AntDesign } from '@expo/vector-icons';
import * as RootNavigation from '../../utils/RootNavigation';

export default function ProjectMilestone({milestone, ...props}) {

  const [alertOptions, setAlertOptions] = React.useState({});

  const scopePlaceholder = [
    'Provide in detail the scope of work that will be involved, be as detailed as possible to avoid misunderstandings.',
    // 'If you have a written quote, you can upload it in the Project Documents section above.',
  ];

  let textInputs = {
    title: React.useRef(null),
    amount: React.useRef(null),
    description: React.useRef(null),
  };

  const stagesDontShowApproval = ['Started', 'Invite Sent', 'Completed'];
  const directionText = milestone.completed ? (milestone.direction === 'Fund' ? 'Funded' : 'Released') : (milestone.direction);

  const toggleAction = (a) => {
    if(!props.editing){ return; }
    props.dispatch({
      type: 'toggleAction',
      uuid: milestone.uuid,
      payload: a,
    });
  }
  const toggleAmountType = (a) => {
    if (!props.editing) { return; }
    props.dispatch({
      type: 'toggleAmountType',
      uuid: milestone.uuid,
      payload: a,
    });
    props.setDefaultAmountType(a);
  }
  const onChangeProjectTitle = (t) => {
    props.dispatch({
      type: 'setTitle',
      uuid: milestone.uuid,
      payload: t,
    })
  }

  const onChangeAmount = (a, amountType) => {
    let payload = {};
    if(amountType === 'dollar'){
      payload.amount = formatAmount(a);
      payload.amount_value = formatAmount(a);
    }else if(amountType === 'percent'){
      payload.amount = formatPercent(a);
      payload.amount_value = formatAmount(a);
    }
    // a = formatCurrency(a);
    console.log('dispatch formattedAmount', a, amountType);
    props.dispatch({
      type: 'setAmount',
      uuid: milestone.uuid,
      payload: payload,
    });
  }

  const onChangeScope = (t) => {
    props.dispatch({
      type: 'setScope',
      uuid: milestone.uuid,
      payload: t,
    })
  }

  const showActionSheet = () =>
  {
    if(!props.editing){ return; }
    if(Platform.OS === 'ios'){
      ActionSheetIOS.showActionSheetWithOptions(
        {
          options: ['Cancel', 'Re-Order Milestones', 'Remove Milestone'],
          destructiveButtonIndex: 2,
          cancelButtonIndex: 0,
        },
        buttonIndex => {
          if (buttonIndex === 0) {
            // cancel action
          } else if (buttonIndex === 1) {
            props.showOrdering();
          } else if (buttonIndex === 2) {
            confirmDeleteMilestone();
          }
        }
      );
    }else{
      // confirmDeleteMilestone();
      // return;
      let options = { visible: true, title: 'Choose Action', message: 'Choose an action to perform', };
      options.buttons = [
        {
          text: 'Re-Order Milestones',
          onPress: () => props.showOrdering(),
        },
        {
          text: 'Remove Milestone',
          onPress: () => confirmDeleteMilestone(),
        },
        {
          text: 'Cancel',
          onPress: null,
          style: 'cancel',
        }
      ];
      setAlertOptions(options);
    }
    
  }
  const confirmDeleteMilestone = () => {
    // Alert.alert(
    //   'Confirm',
    //   'Are you sure you want to remove this milestone?',
    //   [
    //     {
    //       text: 'Cancel',
    //       onPress: null,
    //       style: 'cancel',
    //     },
    //     {
    //       text: 'Remove',
    //       onPress: () => props.dispatch({
    //         type: 'removeMilestone',
    //         uuid: milestone.uuid,
    //       }),
    //       style: 'destructive',
    //     },
    //   ],
    //   { cancelable: false }
    // );
    let options = { visible: true, title: 'Confirm', message: 'Are you sure you want to remove this milestone?', };
    options.buttons = [
      {
        text: 'Remove',
        onPress: () => props.dispatch({
          type: 'removeMilestone',
          uuid: milestone.uuid,
        }),
        style: 'destructive',
      },
      {
        text: 'Cancel',
        onPress: null,
        style: 'cancel',
      },
    ];
    setTimeout(() => {
      setAlertOptions(options);
    }, 100);
  }
  const pendingApproval = (field) => {
    console.log('pendingApproval(): ', field);
    setAlertOptions({ visible: true, title: 'Warning', message: `This ${field} change is pending approval from the ${props.isContractor ? 'homeowner' : 'contractor'}`, });
    // Alert.alert(`This ${field} change is pending approval from the ${props.isContractor ? 'homeowner' : 'contractor'}`);
  }
  if(milestone.deleted){ return null; }
  if(props.editing){
    if(milestone.direction === 'Return'){ return null; }
    return (
      <View style={styles.milestone}>
        <Alert options={alertOptions} setOptions={setAlertOptions} />
        {milestone.completed && (
          <View style={styles.completedContainer}>
            <Ionicons name="ios-checkmark-circle-outline" size={48} color={Colors.lightBlue2} style={styles.icon} />
            <Text style={[CS.smallTitle, CS.lightBlueText, styles.completedTitle]}>{milestone.title}</Text>
          </View>
        )}
        {!milestone.completed && (
          <View style={styles.container}>
            <View style={styles.iconsLine}>
              <TouchableOpacity style={styles.icon} activeOpacity={0.6} onPress={showActionSheet}>
                <FontAwesome name="circle-thin" size={48} color={Colors.lightBlue2} />

                {/* <MaterialCommunityIcons name="circle-outline" size={48} color={Colors.lightBlue2} /> */}
                {/* <MaterialCommunityIcons name="dots-horizontal" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
                {/* <FontAwesome5 name="circle" size={48} color={Colors.lightBlue2} /> */}
                
                {/* <Ionicons name="ios-add-circle-outline" size={48} color={Colors.lightBlue2} /> */}
                {/* <Ionicons name="md-move" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
                {/* <Ionicons name="ios-menu" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
                {/* <Ionicons name="md-reorder" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
                {/* <Entypo name="menu" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
                <Entypo name="dots-three-horizontal" size={24} color={Colors.lightBlue2} style={styles.move} />
                {/* <Feather name="edit-2" size={24} color={Colors.lightBlue2} style={styles.move} /> */}
              </TouchableOpacity>
              <View style={styles.line}></View>
            </View>
            <View style={styles.editContainer}>
              {/* action */}
              {props.showDirection &&
                <View style={styles.buttons}>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => toggleAction('Fund')} style={styles.buttonContainer}>
                    <View style={[styles.button, styles.buttonLeft, milestone.direction === 'Fund' && styles.buttonActive]}>
                      <Text style={[CS.smallText, CS.boldText, milestone.direction === 'Fund' ? CS.darkText : CS.lightText]}>Fund the Project</Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => toggleAction('Release')} style={styles.buttonContainer}>
                    <View style={[styles.button, styles.buttonRight, milestone.direction === 'Release' && styles.buttonActive]}>
                      <Text style={[CS.smallText, CS.boldText, milestone.direction === 'Release' ? CS.darkText : CS.lightText]}>Release Funds</Text>
                    </View>
                  </TouchableOpacity>
                </View>
              }
              {(!props.isNew && !milestone.accepted && !stagesDontShowApproval.includes(props.projectStage)) &&
                <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApproval('milestone')} style={{ marginBottom: 5 }}>
                  <AntDesign name="exclamationcircle" size={24} color={Colors.yellow}/>
                </TouchableOpacity>
              }
              {/* title */}
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Milestone name</Text>
              <TextInputContainer
                placeholder='Name this stage'
                onChangeText={(t) => onChangeProjectTitle(t)}
                inputRef={textInputs.title}
                // isInvalid={isInvalid.projectDescription}
                returnKeyLabel='next'
                value={milestone.title}
                autoCorrect={false}
                spellCheck={true}
                // selectTextOnFocus={true}
                onSubmitEditing={() => textInputs.amount.current.focus()}
                returnKeyType='next'
                inputContainerStyle={{ marginBottom: 10 }}
                editable={props.editing}
              />
              {/* amount */}
              <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Amount to {milestone.direction === 'Release' ? 'Release' : 'Fund'}</Text>
              <View style={styles.amountContainer}>
                {/* <Text style={[CS.smallText, CS.lightBlueText, styles.dollarSign]}>$</Text> */}
                <TextInputContainer
                  placeholder='Amount'
                  onChangeText={(t) => onChangeAmount(t, milestone.amount_type)}
                  inputRef={textInputs.amount}
                  // isInvalid={isInvalid.projectDescription}
                  returnKeyLabel='next'
                  value={milestone.amount}
                  autoCorrect={false}
                  onSubmitEditing={() => textInputs.description.current.focus()}
                  onFocus={() => props.onFocusAmount(milestone)}
                  onBlur={() => props.onBlurAmount(milestone)}
                  returnKeyType='next'
                  // inputStyle={{ textAlign: 'right' }}
                  inputContainerStyle={{ marginBottom: 10, flex:2, }}
                  keyboardAppearance='dark'
                  keyboardType='numeric'
                  editable={props.editing}
                />
                {!props.existing && 
                <View style={[styles.buttons, { marginLeft: 5, }]}>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => toggleAmountType('dollar')} style={styles.buttonContainer}>
                    <View style={[styles.button, styles.buttonLeft, milestone.amount_type === 'dollar' && styles.buttonActive]}>
                      <Text style={[CS.smallText, CS.boldText, milestone.amount_type === 'dollar' ? CS.darkText : CS.lightText]}>$</Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity activeOpacity={0.6} onPress={() => toggleAmountType('percent')} style={styles.buttonContainer}>
                    <View style={[styles.button, styles.buttonRight, milestone.amount_type === 'percent' && styles.buttonActive]}>
                      <Text style={[CS.smallText, CS.boldText, milestone.amount_type === 'percent' ? CS.darkText : CS.lightText]}>%</Text>
                    </View>
                  </TouchableOpacity>
                </View>
                }
              </View>
              {/* scope */}
              <View style={[CS.rowContainer, styles.inputLabel]}>
                <Text style={[CS.smallText, CS.lightBlueText]}>Scope of Work</Text>
                <ToolTipWrapper
                  text={scopePlaceholder}
                />
              </View>
              <TextInputContainer
                placeholder={Platform.OS !== 'web' ? 'Provide in detail the scope of work that will be involved' : scopePlaceholder.join(' ')}
                // placeholder='Describe the details of the work to be done for this milestone'
                onChangeText={(t) => onChangeScope(t)}
                inputRef={textInputs.description}
                // isInvalid={isInvalid.projectDescription}
                returnKeyLabel='next'
                value={milestone.description}
                autoCorrect={false}
                spellCheck={true}
                multiline={true}
                // returnKeyType='return'
                inputContainerStyle={{marginBottom: 0}}
                inputStyle={styles.description}
                numberOfLines={2}
                editable={props.editing}
              />
            </View>
          </View>
        )}
      </View>
    );
  } else {
    return (
      <TouchableOpacity style={styles.milestone} activeOpacity={0.6} onPress={() => { props.goToMilestone(milestone) }}>
        <Alert options={alertOptions} setOptions={setAlertOptions} />
        <View style={styles.container}>
          <View style={styles.iconsLine}>
            <View style={styles.icon}>
              <FontAwesome name="circle-thin" size={48} color={milestone.current ? Colors.yellow : (milestone.completed ? Colors.green : Colors.lightBlue2)} />
              {milestone.completed &&
                <FontAwesome name="check" size={24} color={Colors.green} style={styles.move} />
              }
              {milestone.current &&
                <FontAwesome name="info" size={24} color={Colors.yellow} style={styles.move} />
              }
            </View>
            {!props.last && 
              <View style={[styles.line, (milestone.completed && styles.lineCompleted)]}></View>
            } 
          </View>
          <View style={[styles.editContainer, !milestone.completed && styles.editContainerNotCompleted, milestone.current && styles.editContainerCurrent, milestone.completed && styles.editContainerCompleted]}>
            <View style={CS.rowContainer}>
              <View style={CS.flex}>
                <View style={[CS.rowContainer, { marginBottom: 5 }]}>
                  <Text style={[CS.mediumText, CS.boldText, (milestone.completed ? CS.darkText : (milestone.current ? CS.darkText : CS.blueText))]}>{milestone.title}</Text>
                  {(!props.isNew && !milestone.accepted && !stagesDontShowApproval.includes(props.projectStage)) &&
                    <TouchableOpacity activeOpacity={0.6} onPress={() => pendingApproval('milestone')}>
                      {/* <AntDesign name="exclamationcircle" size={24} color={(milestone.completed ? Colors.lightBlue2 : Colors.blue)} style={{ marginLeft: 5 }} /> */}
                      <AntDesign name="exclamationcircle" size={24} color={Colors.yellow} style={{ marginLeft: 5 }} />
                    </TouchableOpacity>
                  }
                </View>
                {milestone.description ?
                  <Text style={[CS.smallText, (milestone.completed ? CS.darkText : (milestone.current ? CS.darkText : CS.blueText)), { marginBottom: 5 }]}>{milestone.description}</Text>
                  :
                  null
                }
                <Text style={[CS.smallText, CS.boldText, (milestone.completed ? CS.darkText : (milestone.current ? CS.darkText : CS.blueText))]}>{directionText} {milestone.amount}</Text>
              </View>
              <Entypo name="chevron-thin-right" size={20} color={milestone.completed ? Colors.darkGrey : (milestone.current ? Colors.darkGrey : Colors.blue)} />
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
    }
}

const styles = StyleSheet.create({
  milestone: {
    marginBottom: 20,
  },
  completedContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  amountContainer: {
    flexDirection: 'row',
    // alignItems: 'center',
  },
  dollarSign: {
    marginBottom: 10,
    marginRight: 5,
  },
  iconsLine: {
    alignItems: 'center',
    marginRight: 10,
    // backgroundColor: 'pink',
    height: '100%', 
  },
  icon: {
    alignItems:'center',
    justifyContent:'center',
  },
  move: {
    position: 'absolute',
    // top: 12,
    // left: 9,
  },
  line: {
    width: 1,
    height: '100%',
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    flex:1,
    marginBottom: -31,
    top:-5
  },
  lineCompleted: {
    borderStyle: 'solid',
  },
  completedTitle: {
    marginLeft: 10,
    top: -3
  },
  inputLabel: {
    marginBottom: 7,
  },
  editContainer: {
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    flexGrow: 1,
    // flexWrap: 'wrap',
    flex: 1,
  },
  editContainerNotCompleted: {
    backgroundColor: Colors.lightBlue2,
  },
  editContainerCurrent: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  editContainerCompleted: {
    borderColor: Colors.green,
    backgroundColor: Colors.green,
  },
  buttons: {
    // marginVertical: 15,
    marginBottom: 10,
    flexDirection: 'row',
    flex: 1,
  },
  buttonContainer: {
    flex: 1,
  },
  button: {
    paddingVertical: 15,
    paddingHorizontal: 5,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.textInputBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonActive: {
    backgroundColor: Colors.yellow,
  },
  buttonLeft: {
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
  },
  buttonRight: {
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
  },
  description: {
    // height: 80,
    height: 105,
    textAlignVertical: 'top',
  },
});

